// @gs/feedback/client — filtre de la liste (helper PUR, teste sans DOM —
// pattern coherence.ts apps/ug). CHORE-FBK-UNREAD-INBOX ajoute `unreadOnly`
// (pattern boite courriel, demande Marc). CHORE-FBK-FILTERS-MULTI : les
// facettes type/statut/priorite deviennent MULTI-VALEURS (norme Linear/GitHub) —
// semantique OU a l'interieur d'une facette, ET entre facettes ; facette VIDE
// = tous (les selects mono-valeur 'ALL' sont remplaces par GsFacetFilter).
// CHORE-FBK-LIFECYCLE : les tickets ARCHIVED sont MASQUES par defaut (pattern
// Gmail — archiver = sortir de la vue active) ; la facette Statut les ramene.
// feat-feedback-les-nouveautes-se-publient (F-FBK-20) : le filtre de NATURE « Tout / Commentaires /
// Nouveautes » (prototype FeedbackBoard.tsx:160, setKindFilter) ; absent ou 'ALL' = tout.
import { ARCHIVED_STATUS, ticketKind, type TicketDto, type TicketKind } from '../schemas';
import { normalizeOriginBcKey } from './originApp';

/** Choix du filtre de nature : tout, ou une seule nature. */
export type KindFilter = 'ALL' | TicketKind;
export const KIND_FILTERS: readonly KindFilter[] = ['ALL', 'FEEDBACK', 'ANNOUNCEMENT'];

export interface TicketFilters {
  /** Nature (F-FBK-20) — absente ou 'ALL' = tout. Un ticket sans nature est un commentaire. */
  kind?: KindFilter;
  search: string;
  /** Codes FEEDBACK_TYPES selectionnes — VIDE = tous (OU intra-facette). */
  types: string[];
  /** Codes FEEDBACK_STATUSES selectionnes — VIDE = tous. */
  statuses: string[];
  /** Codes FEEDBACK_PRIORITIES selectionnes — VIDE = tous. */
  priorities: string[];
  /** origin_bc_key normalises selectionnes — VIDE = toutes les apps (OU intra-facette). */
  originApps: string[];
  /** Inbox : ne garder que les tickets avec activite non vue (tk.unread). */
  unreadOnly: boolean;
}

export function filterTickets(tickets: TicketDto[], f: TicketFilters): TicketDto[] {
  const q = f.search.trim().toLowerCase();
  return tickets.filter((tk) => {
    if (f.unreadOnly && !tk.unread) return false;
    if (f.kind && f.kind !== 'ALL' && ticketKind(tk) !== f.kind) return false;
    // Archives masquees par defaut (CHORE-FBK-LIFECYCLE) : un ticket ARCHIVED ne
    // reste dans la vue QUE si la facette Statut le reclame explicitement
    // (« onglet Archives » via GsFacetFilter, aucun nouveau pattern). Le statut
    // terminal ARCHIVED (mig 116) EST le mecanisme d'archivage — pas de flag.
    if (tk.status === ARCHIVED_STATUS && !f.statuses.includes(ARCHIVED_STATUS)) return false;
    // ET entre facettes ; OU dans la facette (includes) ; vide = pas de filtre.
    if (f.types.length > 0 && !f.types.includes(tk.type)) return false;
    if (f.statuses.length > 0 && !f.statuses.includes(tk.status)) return false;
    if (f.priorities.length > 0 && !f.priorities.includes(tk.priority)) return false;
    if (f.originApps.length > 0 && !f.originApps.includes(normalizeOriginBcKey(tk.originBcKey))) return false;
    if (!q) return true;
    return (
      tk.title.toLowerCase().includes(q) ||
      tk.ticketNumber.toLowerCase().includes(q) ||
      tk.createdByName.toLowerCase().includes(q)
    );
  });
}
